/* global google */
/* global ParamsData */
export default blockInformationsMap => {
    const dataLat = blockInformationsMap.getAttribute('data-lat');
    const dataLng = blockInformationsMap.getAttribute('data-lng');

    function initInformationsMap() {
        const position = new google.maps.LatLng(dataLat, dataLng);
        
        const informationsMap = new google.maps.Map(blockInformationsMap, {
            zoom: 14,
            center: position,
            draggableCursor: 'auto',
            navigationControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            zoomControl: true,
            scaleControl: true,
            draggable: true,
            styles: [
                {
                    featureType: 'administrative',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#444444',
                        },
                    ],
                },
                {
                    featureType: 'landscape',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#F2F2F2',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'all',
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 45,
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'simplified',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'all',
                    stylers: [
                        {
                            color: '#A3C9D8',
                        },
                        {
                            visibility: 'on',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#B9D5EC',
                        },
                    ],
                },
            ],
        });
        /*const marker = new google.maps.Marker({
            position,
            map: informationsMap,
            clickable: false,
            icons: [{
                icon: symbolOne,
                offset: "0%"
            }],
        });
        console.log(dataMarker);*/

        // Custom Markers for Golfs
        let golfMarkerColor = getComputedStyle(document.documentElement).getPropertyValue('--theme-primary');
        golfMarkerColor = golfMarkerColor.replace(/\s+/g,'');
        const golfSVGMarker = '<svg xmlns="http://www.w3.org/2000/svg" width="31.2" height="51" viewBox="0 0 31.2 51"><ellipse cx="15.6" cy="50" rx="6.5" ry="1"/><path d="M15.6 0C7 0 0 7.6 0 16.9S11.6 49 15.6 49s15.6-22.8 15.6-32.1S24.2 0 15.6 0z" fill-rule="evenodd" clip-rule="evenodd" fill="'+ golfMarkerColor +'"/><ellipse cx="15.6" cy="15.8" rx="10.6" ry="10.7" fill-rule="evenodd" clip-rule="evenodd" fill="#fff"/></svg>';
        const dataMarker = document.documentElement.dataset.theme != 'portail' ? 'data:image/svg+xml;utf-8,'+golfSVGMarker : `${ParamsData.wp_theme_url}assets/img/pin-yello.svg`;
    
        // Set Custom Icon for Golfs, or default OGC Yellow icon
        if( document.documentElement.dataset.theme != 'portail' ){
            
            var golfMarkerSymbol = {
                path: "M15.6,0C7,0,0,7.6,0,16.9C0,26.2,11.6,49,15.6,49s15.6-22.8,15.6-32.1C31.2,7.6,24.2,0,15.6,0z M15.6,26.5C9.75,26.5,5,21.71,5,15.8C5,9.89,9.75,5.1,15.6,5.1c5.85,0,10.6,4.79,10.6,10.7C26.2,21.71,21.45,26.5,15.6,26.5z",
                fillColor: golfMarkerColor,
                fillOpacity: 1,
                scale: 1,
                strokeWeight: 0,
                anchor: new google.maps.Point(15, 50)
            };

        } else {

            var golfMarkerSymbol = {
                url: `${ParamsData.wp_theme_url}assets/img/pin-yellow.svg`,
                size: new google.maps.Size(30, 50),
                scaledSize: new google.maps.Size(30, 50),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(15, 50),
            }

        }
            
        var marker = new google.maps.Marker({
            position,
            map: informationsMap,
            clickable: false,
            icon: golfMarkerSymbol,
        });

    }

    initInformationsMap();
};
